import { useEffect, useState } from "react";
import apiClient from "../../../shared/API/apiClient";
import { useReportingYear } from "../../../context/ReportingYearContext";
import { useNavigate } from "react-router-dom";
import {Trash2,AlertTriangle,Package,Recycle,Percent} from "lucide-react";
import { useLocation } from "react-router-dom";

// number format
const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  return parseFloat(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// icon mapping
const iconMap = {
  trash: <Trash2 size={16} />,
  "alert-triangle": <AlertTriangle size={16} />,
  package: <Package size={16} />,
  recycle: <Recycle size={16} />,
  percent: <Percent size={16} />,
};

const getIcon = (name) => iconMap?.[name] ?? null;

// Metric Card
const MetricCard = ({
  title,
  value,
  unit,
  desc,
  icon,
  link,
  route,
  selectedEntity,
}) => {
  const navigate = useNavigate();

  const { reportingYearId } = useReportingYear();

  return (
    <div className="metric-card">
      <div className="metric-card__header">
        <span className="metric-card__title">{title}</span>
        <span className="metric-card__icon">{icon}</span>
      </div>

      <div className="metric-card__value-row">
        <span className="metric-card__value">{value}</span>
        <span className="metric-card__unit">{unit}</span>
      </div>

      <div className="metric-card__desc">{desc}</div>

      {route && (
        <button
          className="metric-card__link"
          onClick={() =>
            navigate(route, {
              state: {
                reporting_year_id: reportingYearId,
                legal_entity_id: selectedEntity,
              },
            })
          }
        >
          {link}
          <span className="metric-card__arrow">→</span>
        </button>
      )}
    </div>
  );
};

export default function WasteSummary() {
  const { reportingYear, reportingYearId } = useReportingYear();
const location = useLocation();
  const [legalEntities, setLegalEntities] = useState([]);
  // const [selectedEntity, setSelectedEntity] = useState("");
  const [cards, setCards] = useState([]);
  

    const STORAGE_KEY = "waste_filters";

  // FIRST declare this
  const [selectedEntity, setSelectedEntity] = useState(() => {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved).legal_entity_id : "";
  });

  // Fetch Legal Entities
  useEffect(() => {
    if (!reportingYearId) return;

    const fetchEntities = async () => {
      try {
        const res = await apiClient.get("/api/legal-entities-by-year", {
          params: { reporting_year_id: reportingYearId },
        });

        if (res.data.code === 200) {
          const entities = res.data.data || [];
        setLegalEntities(entities);
        const entityId = location.state?.legalEntityId;
        if (
            entityId &&
            entities.some(e => Number(e.entity_id) === Number(entityId))
        ) {
            setSelectedEntity(String(entityId));
        }
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchEntities();
  }, [reportingYearId]);

  // Fetch Water Summary Cards
  useEffect(() => {
    if (!reportingYearId || !selectedEntity) return;

    const fetchWasteSummary = async () => {
      try {
        const res = await apiClient.get("/api/waste-summary", {
          params: {
            reporting_year_id: reportingYearId,
            legal_entity_id: selectedEntity,
          },
        });

        if (res.data.code === 200) {
          const apiCards = res.data.cards || [];

          const formattedCards = apiCards.map((card) => ({
            ...card,
            value: formatNumber(card.value),
            unit:card.unit === "kg"? "kg": card.unit,
            icon: getIcon(card.icon),
          }));

          setCards(formattedCards);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchWasteSummary();
  }, [reportingYearId, selectedEntity]);



  return (
    <div className="dash-page">
      <div className="dash-page-title">
          Waste Summary
    </div>

        <div className="dash-page-subtitle">
          Track waste generation, recycling, and diversion for sustainability reporting
        </div>

      {/* Filter */}
      <div className="filter-card">
        <div className="filter-group">
          <label>Reporting Year</label>
          <input className="filter-input" value={reportingYear} disabled />
        </div>

        <div className="filter-group">
          <label>Legal Entity</label>
          <select
            className="filter-input"
            value={selectedEntity}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedEntity(value);

              sessionStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({
                  reporting_year_id: reportingYearId,
                  legal_entity_id: value,
                })
              );
            }}
          >
            <option value="">Select</option>
            {legalEntities.map((e) => (
              <option key={e.entity_id} value={e.entity_id}>
                {e.entity_name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Cards */}
      {cards.length > 0 ? (
          
      <div className="env-grid">
      {cards.map((card, i) => (
            <MetricCard key={i} {...card} selectedEntity={selectedEntity} />
             ))}
      </div>
        ) : (
       
      <div className="empty-entity">
          <div className="empty-entity__icon"><i className="fa-solid fa-building" /></div>
          <div className="empty-entity__title">Select a Legal Entity to continue</div>
          <div className="empty-entity__sub">
            Choose a legal entity from the filter above to view the waste summary.
          </div>
          
          
        
        </div>
        )}
    </div>
  );
}
